import React, {forwardRef} from "react";
import classNames from "classnames";
import css from "./CardList.module.scss";

const CardList = forwardRef(({children, className, ...rest}, ref) => {
  return (
    <div
      role="list"
      className={classNames(css.cardList, className)}
      ref={ref}
      {...rest}>
      {children}
    </div>
  );
});

export default CardList;
